import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ProductViewHelperService } from './../../services/product-view-helper.service';
import { LoaderService } from 'modules/app/services/loader.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { UserAttemptHelper } from './../../services/user-attempt-helper.service'

import { LTILaunchService } from '../../services/lti-launch.service';
import { UserAttempt } from './../../interfaces/user-attempt.model';
import { AjaxResponse } from './../../interfaces/ajax-response';
import { MetadataTagsConstants, TestSubTypeConstants } from '../../../shared-all/constants/test.constants';
import { TestHelperService } from './../../../shared-postlogin/services/test-helper.service';
import { ltiToolRefs } from '../../../shared-all/constants/lti.constants';
import { litmusFamilyCodes, litmusBundleCodes } from 'libs-frontend-micro-base/data/litmus-family-mapping.js';
import { AuthService } from 'modules/app/services/auth.service';
import { configService } from "libs-frontend-micro-base";
import { config } from 'config';

@Component({
    selector: 'generic-lti',
    templateUrl: './generic-lti.template.html',
    styleUrls: ['./generic-lti.style.scss'],
    standalone: false
})

export class GenericLti implements OnInit {
  @Input('selectedItemData') selectedItemData :any;
  @Input('isLitmusAvailable') isLitmusAvailable : boolean = true;
  isLearner: boolean = false;
  productCode: string
  spaceId: string;
  classId: string;
  assignmentId: string;
  ltiLaunchParams: any;
  pageSource : string;
  learnerId: string;
  accessibleUnitCode: string;
  accessibleActivityId: string;
  ltik: string;
  cid: string;
  ltiGiId: string;
  rcode: string;
  launchMode: string;
  numberOfAttemptAllowed: number;
  iscbp: boolean = false;
  productTOCData:any;
  loaderText: string;
  attemptsLeft: number;
  showLitmusTestCopy: boolean = false;
  reviewModes : any = {
    TEST : 'test',
    ANSWERS : 'answers'
  }
  litmusUnavailModalDesc: string;
  @ViewChild('litmusServiceDownModalButton') litmusServiceDownModalButton: ElementRef;
  assignability : number;
  remedialPracticeURL: string;
  @ViewChild('launchNotSupportedModalButton') launchNotSupportedModalButton: ElementRef;
  disableLaunchToolBtn = false;

  public pluralMapping;
  public userData: any = {};
  public displaySingleAttemptInstruction: boolean = false;
  public hideReviewBtn: boolean = false;
  public imageBasePath: string = IMAGES_BASEPATH;

  constructor(
    private productViewHelperService: ProductViewHelperService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private ltiLaunchService : LTILaunchService,
    private appHelperService: AppHelperService,
    private userAttemptHelperService : UserAttemptHelper,
    private translateService: TranslateService,
    private testHelperService:TestHelperService,
    private authService : AuthService) { 
      this.translateService.get('SHARED.GENERIC_LTI.LOADER_TEXT').subscribe((loaderText)=>{
        this.loaderText = loaderText;
      })
      this.pluralMapping = this.appHelperService.pluralMapping;
    }

  ngOnInit() {
    this.userData = this.authService.getUserData() || {};
    this.pageSource = this.route.snapshot.data.source;
    this.productTOCData = this.route.parent.snapshot.data.resolveData.productData;
    this.ltik = this.route.snapshot.queryParams.ltik;
    this.cid = this.route.snapshot.queryParams.cid;
    this.ltiGiId = this.route.snapshot.queryParams.ltiGiId;
    this.rcode = this.route.snapshot.queryParams.rcode;
    let presentInLFC, presentInLBC;
    if(litmusFamilyCodes[DLS_ENV]) {
      presentInLFC = litmusFamilyCodes[DLS_ENV].some(familyCode =>this.productTOCData.bundleDetails["family-codes"].includes(familyCode));
    }
    if(litmusBundleCodes[DLS_ENV]) {
      presentInLBC = litmusBundleCodes[DLS_ENV].some(bundleCode => bundleCode === this.productTOCData.bundleDetails["bundle-code"]);
    }
    this.showLitmusTestCopy = presentInLFC || presentInLBC;
    if (this.ltiLaunchService.launchSources.indexOf(this.pageSource) === -1) {
      this.appHelperService.navigateToDashboardApp([], { forceExit: true });
      return;
    }

    if (this.pageSource.includes('LEARNER')) {
      this.isLearner = true;
    }

    this.route.parent.params.subscribe((params: Params) => {
      this.productCode = params.productcode;
      this.spaceId = params.spaceid;
      this.classId = params.classid;
      this.assignmentId = params.assignmentid;
      this.learnerId = params.userid;
      this.accessibleUnitCode = params.unitcode;
      this.accessibleActivityId = params.activityId;
    });

    this.route.params.subscribe((params: Params) => {
      const productData = this.productTOCData.bundleDetails.products.find((product) => product['dls-product'].code === this.productCode);
      this.numberOfAttemptAllowed = productData.activity && productData.activity['attempts-allowed'];
      const submitCount = this.selectedItemData.__analytics && this.selectedItemData.__analytics.submitCount;
      this.attemptsLeft = this.numberOfAttemptAllowed && this.numberOfAttemptAllowed - submitCount;  
      this.assignability = productData.assignability && productData.assignability['item-limit'];
      this.remedialPracticeURL = this.getRemedialPracticeURL();
      this.iscbp = this.productTOCData.classmeta && this.productTOCData.classmeta.analyticsharingmodel === 'NOINHERIT_SYNCBACK';

      // To show the close activity button for Test component preview on Create Access Rule page
      if (this.pageSource === 'CREATE_ACCESS_RULE') {
        const isTestTypeComponent = this.productViewHelperService.isTestTypeComponent(productData);

        if (isTestTypeComponent) {
          this.productViewHelperService.closeActivityBtnSubject.next({ visible: true });
        }
      }

    });

    this.ltiLaunchService.getLtiLaunchParams(this.selectedItemData[this.selectedItemData["sub-type"]]['tool-ref']).toPromise().then((ltiParams) => {
      this.ltiLaunchParams = ltiParams;
      this.loaderService.hideLoader();
    })

    if (!this.isLitmusAvailable) {
      if (this.pageSource === 'TEACHER_CREATE_ASSIGNMENT') {
        this.litmusUnavailModalDesc = 'SHARED.GENERIC_LTI.LITMUS_DOWN_MSG2';
      }
      else {
        this.litmusUnavailModalDesc = 'SHARED.GENERIC_LTI.LITMUS_DOWN_MSG1';
      }
    }
    // Hide review button in case of Competency Test when launched from LTI
    const testTypeTag = this.testHelperService.getTestTypeTagFromItem(this.selectedItemData);
    if(testTypeTag === TestSubTypeConstants['competency'] && this.userData && this.userData.launchType === 'lti') {
      this.hideReviewBtn = true;
    }

    if (testTypeTag === TestSubTypeConstants.practice && this.isLearner && this.numberOfAttemptAllowed === 1) {
      this.displaySingleAttemptInstruction = true;
    }
  }
  async launchTool(launchMode?) {
    if (launchMode != 'review') {
      this.disableLaunchToolBtn = true;
      setTimeout(() => {
        this.disableLaunchToolBtn = false;
      }, config.disableLaunchBtnTimeSpan);
    }

    const extLinkStatementId = this.appHelperService.generateNanoId();
    let isActivityLaunchSupported = true;
    if (launchMode != 'review') {
      if (this.productTOCData.meta && this.productTOCData.meta.isProductExpired) {
        this.appHelperService.showLoaderAndNavigateToDashboard(this.userData);
        return;
      }
      const isListeningActivity = this.selectedItemData.mappedTags?.some(tag => tag.includes(MetadataTagsConstants.LISTENING_LABEL));
      // In case of safari browser and listening activity do not launch test.
      isActivityLaunchSupported = !(isListeningActivity && this.appHelperService.isSafariUA());
    }

    if (!isActivityLaunchSupported) {
      this.launchNotSupportedModalButton.nativeElement.click();
      return;
    }
    // Bypass litmus downtime flag if MQA org.
    if (!this.isLitmusAvailable && !(this.productTOCData.orgId && this.appHelperService.checkMQAUsingDlsOrgId(this.productTOCData.orgId))) {
      const itemSubType = this.selectedItemData && this.selectedItemData["sub-type"];
      const itemToolRef = itemSubType && this.selectedItemData[itemSubType] && this.selectedItemData[itemSubType]['tool-ref'];
      if (ltiToolRefs.indexOf(itemToolRef) !== -1) {
        this.litmusServiceDownModalButton.nativeElement.click();
        return;
      }
    }

    this.launchMode = launchMode;
    const windowRef = window.open('');
    windowRef.document.write(this.getLoaderHtml());
    const attemptErrorRedirectUrl = `${window.location.origin}${this.ltiLaunchParams.returnBaseUrl}learner/lti/attempts-exceeded/${this.numberOfAttemptAllowed}`

    if (this.launchMode != 'review' && this.numberOfAttemptAllowed && this.selectedItemData.__analytics && this.selectedItemData.__analytics.submitCount >= this.numberOfAttemptAllowed) {
      windowRef.location.replace(attemptErrorRedirectUrl);
      return;
    }    

    const userAttemptRes = await this.getAttempt();
    if (!userAttemptRes.success && userAttemptRes.statusCode === 409) {
      if(this.isLearner){
        windowRef.location.replace(attemptErrorRedirectUrl);
      }
      return;
    }

    // fix for NEMO-9283
    const testSpecificAttemptNo = this.getTestSpecificAttemptNo(userAttemptRes.data.submitCount);

    if(testSpecificAttemptNo) {
      userAttemptRes.data.testSpecificAttemptNo = testSpecificAttemptNo;
      if (userAttemptRes && userAttemptRes.data && !isNaN(userAttemptRes.data.submitCount)) {
        this.attemptsLeft = this.numberOfAttemptAllowed && this.numberOfAttemptAllowed - userAttemptRes.data.submitCount;
      }
    }
    const ltiParams = {
      spaceId: this.spaceId,
      productCode: this.productCode,
      bundleCode: this.productTOCData.bundleDetails['bundle-code'],
      itemCode: this.selectedItemData['item-code'],
      classId: this.classId,
      assignmentId: this.assignmentId,
      attempt: userAttemptRes.data,
      attemptsLeft: this.attemptsLeft,
      pageSource: this.pageSource,
      launchMode: this.launchMode,
      testTypeTag: this.selectedItemData.testTypeTag,
      contributesToCompletionFlag: this.selectedItemData['contributes-to-completion'],
	  accessibleUnitCode: this.accessibleUnitCode,
      accessibleActivityId: this.accessibleActivityId,
      extLinkStatementId,
      ltik: this.ltik,
      cid: this.cid,
      ltiGiId: this.ltiGiId,
      rcode: this.rcode,
    }

    if (this.learnerId) {
      ltiParams['learnerId'] = this.learnerId;
    }
    const ltiParamsIdentifier = this.ltiLaunchService.setDataInLocalStorage(ltiParams);      
    const initParams = this.productViewHelperService.getLOInitParams(); 
    const contentType = this.selectedItemData["sub-type"];
    
    let routeSuffix = 'teacher/lti/submit';
    if (this.isLearner) {
      routeSuffix = 'learner/lti/submit';
    }


    initParams.learningObject[contentType] =  {
        toolTestId: this.selectedItemData[contentType]['tool-uid']
    };
    initParams.container = {
        type: contentType,
        config: {
            trackLaunch: true,
            attempt: userAttemptRes.data
        }
    }
    initParams.container[contentType] = {
      invokeUrl: this.ltiLaunchParams.gatewayBaseUrl,
      toolDeploymentId: this.ltiLaunchParams.deploymentId,
      returnUrl: `${window.location.origin}${this.ltiLaunchParams.returnBaseUrl}${routeSuffix}/${ltiParamsIdentifier}`,
      documentTarget: this.ltiLaunchParams.documentTarget,
      loader: this.ltiLaunchParams.loader,
      ignoreScore: this.isIgnoreScore(),
      extLinkStatementId
    }
    
    // custom object will now always be created to support fresh test, refer NEMO-10314
    initParams.container[contentType].custom = {
      context: this.getLitmusContextId()
    }

    if (this.checkIfPrepopulateTest() && this.launchMode !== 'review' && this.launchMode !== 'preview') {
      initParams.container[contentType].custom.action = 'prepopulate';
    }

    if( this.launchMode === 'preview') {
      initParams.container[contentType].custom.action = 'preview';
    }
    
    // For 'TEACHER_CEFR_REVIEW_TEST' launch mode review is being used and track launch is set to false. 
    if(this.pageSource === 'TEACHER_REVIEW_TEST' || this.launchMode === 'review'){
      initParams.container[contentType].custom.action = 'review';
      const testTypeTag = this.testHelperService.getTestTypeTagFromItem(this.selectedItemData);
      if(testTypeTag === TestSubTypeConstants['unit-progress'] || testTypeTag === TestSubTypeConstants['competency'] || testTypeTag === TestSubTypeConstants['practice']) {
        initParams.container[contentType].custom.mode = this.getModeForReview();
      }
      initParams.container.config.trackLaunch = false;
    }
    if(windowRef){
      initParams.container[contentType].windowRef = windowRef;
    }
    this.productViewHelperService.getXAPIRunnerObject().paintActivity(this.selectedItemData['item-code'], 'content-course-ext', initParams);
  }
  async getAttempt(): Promise<AjaxResponse<UserAttempt>> {

    if (this.launchMode === 'review') {
      if(this.pageSource === 'TEACHER_REVIEW_TEST'){
        return {
          success: true,
          data: {
            number: this.getAttemptNoForReview(this.selectedItemData.__analytics)
          }
        }
      }
      return {
        success: true,
        data: {
          number: this.getAttemptNoForReview(this.selectedItemData.__analytics)
        }
      }
    }
    if (this.isLearner) {
      return await this.userAttemptHelperService.getUserAttempt(this.productCode, this.selectedItemData['item-code'], this.classId, this.assignmentId, this.iscbp).toPromise();
    }

    return await this.userAttemptHelperService.getNewAttempt(this.productCode, this.selectedItemData['item-code']).toPromise();
  }
  
  isIgnoreScore(){
    return !(this.pageSource === 'LEARNER_ATTEMPT_ASSIGNMENT' || ((this.pageSource === 'LEARNER_LAUNCH_FROM_DASHBOARD' || this.pageSource === 'LEARNER_REVIEW_TEST' || this.pageSource === 'LEARNER_CEFR_REVIEW_TEST') && this.launchMode !== 'review'));
  }

  getAttemptNoForReview(userAnalytics) {
    if (this.pageSource === 'TEACHER_CEFR_REVIEW_TEST' || this.pageSource === 'LEARNER_CEFR_REVIEW_TEST') {
      if(userAnalytics && userAnalytics.firstResult && userAnalytics.firstResult.review && userAnalytics.firstResult.review.submission_order) {
        return userAnalytics.firstResult.review.submission_order;
      }
    }
    else {
      if(userAnalytics && userAnalytics.lastResult && userAnalytics.lastResult.review && userAnalytics.lastResult.review.submission_order) {
        return userAnalytics.lastResult.review.submission_order;
      }
    }
    return (userAnalytics && userAnalytics.submitCount) || 1;
  }

  checkIfPrepopulateTest() {
    if (!this.isLearner) return;

    return this.checkIfUnitProgressTest();
  }

  getModeForReview() {
    if (this.isLearner && this.selectedItemData.__analytics?.submitCount < this.numberOfAttemptAllowed) {
      return this.reviewModes.TEST;
    }
    return this.reviewModes.ANSWERS;
  }

  checkIfUnitProgressTest() {
    const testTypeTag = this.testHelperService.getTestTypeTagFromItem(this.selectedItemData);
    return testTypeTag === TestSubTypeConstants['unit-progress'];
  }

  getTestSpecificAttemptNo(submitCount) {
    if (!this.checkIfUnitProgressTest()) return;

    // When teacher previews analytics is not present.
    if(!this.selectedItemData.__analytics) return;

    if (submitCount === undefined) submitCount = this.selectedItemData.__analytics.submitCount;

    if (this.launchMode === 'review') return submitCount;

    return submitCount + 1;
  }

  getLitmusContextId() {
    const dlimiter = '#'; // delimiter

    let contextId = `pc${this.productCode}${dlimiter}ic${this.selectedItemData['item-code']}`;

    // for context classes, prefix class id to the litmus context
    if (this.iscbp) { contextId = `ci${this.classId}${dlimiter}${contextId}` }

    return contextId;
  }

  getLoaderHtml(): string{
    let loaderHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <title></title>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <style>
          body {
            margin: 0px;
            background-color: white;
          }
        
          #loader-container {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
            width: 100%;
            background-color: #ffffff;
            flex-direction: column;
          }
        
          .loader {
            box-sizing: border-box;
            border: 15px solid #f4f4f4;
            border-top: 15px solid #8723ff;
            border-radius: 50%;
            width: 120px;
            height: 120px;
            animation: spin 1s linear infinite;
          }
        
          .loader-text {
            font-family: 'Mulish', sans-serif;
            font-size: 18px;
            font-weight: normal;
            margin: 20px;
            text-align: center;
            color: #A9A9A9;
            max-width: 70%;
          }
        
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
        
            100% {
              transform: rotate(360deg);
            }
          }
        </style>
      </head>
      <body>
        <div id="loader-container">
          <div class="loader"></div>
          <p class="loader-text">${this.loaderText}
          </p>
        </div>
      </body>
    </html>`;
    return loaderHtml;
  }

  getRemedialPracticeURL() {
    // This update is specific to learner assignment journey
    if(this.pageSource !== 'LEARNER_REVIEW_TEST' || (this.assignability !== 1) || (!this.selectedItemData.__analytics || !this.selectedItemData.__analytics.completedOnce)) {
      return;
    }

    const remedialPracticeLink = this.selectedItemData.model && this.selectedItemData.model['ext-links'] && this.selectedItemData.model['ext-links'].find((extLink) => extLink.type === 'remedial');
    if (remedialPracticeLink && (!this.numberOfAttemptAllowed || (this.numberOfAttemptAllowed > 1 && this.attemptsLeft > 0))) {
      return remedialPracticeLink.url;
    }
  }

  public gotoHelpPage() {
    this.appHelperService.navigateToApp('', [], { outsideC1Url: configService.getHelpPagePath(APP_ENV), openInNewTab: true });
  }
}
